import {
  Card,
  Flexbox,
  ListManager,
  PageHeader,
  Paginator,
  Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import reports from '@/services/api/reports'
import React from 'react'
import { singularDateMapLabel } from '@/constants/castration'
import FilterCastrations from '../../components/FilterCastrations'
import CardItem from './CardItem'
import QuickFilterPeriodCastrations from '../../components/QuickFilterPeriodCastrations'

function CastrationsByMonth({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const dateRef = query?.s?.dateRef || 'createdAt'
  const { data, loading, error } = useAxiosRequest(
    reports.castrationsByMonth,
    query,
  )

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Castrações por mês"
        subtitle="Quantidade de castrações por mês"
        icon="fas fa-calendar"
        rightAction={() => <FilterCastrations dateRef={dateRef} lockDateRef />}
      />
      <QuickFilterPeriodCastrations />
      <ListManager count={data?.count || 0} loading={loading} error={error}>
        {Boolean(data) && (
          <>
            <Flexbox.Columns>
              <Flexbox.Column className="col-6 col-sm-12 my-2">
                <CardItem
                  item={data?.totalStatus}
                  statusList={data?.statusList}
                />
              </Flexbox.Column>
              <Flexbox.Column className="col-6 col-sm-12 my-2">
                <Card.Base>
                  <Card.Header>
                    <Flexbox.Columns className="align-center">
                      <Flexbox.Column className="col-auto">
                        <i className="fas fa-calendar fa-lg" />
                      </Flexbox.Column>
                      <Flexbox.Column>
                        <div className="h5">Totalizador mensal</div>
                        <small>
                          Referência: {singularDateMapLabel[query?.s?.dateRef] || 'Data de solicitação (padrão)'}
                        </small>
                      </Flexbox.Column>
                    </Flexbox.Columns>
                  </Card.Header>
                  <Card.Body>
                    <div style={{ maxHeight: 650, overflow: 'auto' }}>
                      <table className="table table-hover text-small">
                        <thead>
                          <tr>
                            <th>Mês</th>
                            <th width="100px" className="text-right">
                              Solicitadas
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.monthlyTotals?.map((item) => (
                            <tr key={item.monthString}>
                              <td>{item.monthString}</td>
                              <td className="text-right">{item.total}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>
                </Card.Base>
              </Flexbox.Column>
              {data.rows.map((item) => (
                <Flexbox.Column
                  key={item?.month}
                  className="col-6 col-sm-12 my-2"
                >
                  <CardItem item={item} statusList={data?.statusList} />
                </Flexbox.Column>
              ))}
            </Flexbox.Columns>
            {Boolean(data) && (
              <div className="my-2">
                <Paginator paginatedList={data} />
              </div>
            )}
          </>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default CastrationsByMonth
